import { SWRConfiguration } from 'swr';

import {
  GET_LONG_ABSENCE_HISTORY_SWR_KEY,
  LongAbsence,
  getLongAbsenceHistory,
} from '~/data/absences/index';
import { UseSWROutput, useSWR } from '~/hooks/useSWR';

type PropsType = {
  employeeId: number;
  absenceIds: string[];
};

export const useGetLongAbsencesHistory = (
  props: PropsType,
  swrConfig?: SWRConfiguration,
): UseSWROutput<LongAbsence[]> => {
  const { employeeId, absenceIds } = props;

  return useSWR(
    absenceIds.length > 0
      ? [GET_LONG_ABSENCE_HISTORY_SWR_KEY, employeeId, absenceIds]
      : null,
    ([key_, employeeId, absenceIds]) =>
      Promise.all<LongAbsence[]>(
        absenceIds.map((absenceId: string) =>
          getLongAbsenceHistory(employeeId, absenceId),
        ),
      ).then((results): LongAbsence[] => results.flat()),
    swrConfig,
  );
};
